module.exports = __webpack_public_path__ + "static/media/org-edit.5466b81a.svg";